import React from 'react';
import spinner from './spinner.gif';

export default () => {
    return (
        <span>
      <img
          src={spinner}
          style={{width: '200px', margin: 'auto', display: 'block', backgroundColor: 'transparent'}}
          alt="Loading..."
      />
          </span>
    );
};
